import { AlertCircle } from '@untitled-ui/icons-react';

import { Button } from '../../../../../../components/buttons/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '../../../../../../components/dialog';
import { FeaturedIcon } from '../../../../../../components/featured-icon';
import { tNamespace } from '../../../../../../services/translation';

const tBilling = tNamespace('app.billing.general');
const tSettings = tNamespace('app.settings.organization.billing');

export type AbortDowngradeModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm?: () => void;
  onGoBack?: () => void;
  loading?: boolean;
};

export function AbortDowngradeModal(props: AbortDowngradeModalProps) {
  const { open, onOpenChange, onConfirm, onGoBack, loading } = props;

  function handleGoBack() {
    if (onGoBack != null) {
      onGoBack();
    } else {
      onOpenChange(false);
    }
  }

  function handleConfirm() {
    if (onConfirm != null) {
      onConfirm();
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hasCloseButton className="w-[480px] max-w-full">
        <div className="flex flex-col gap-6">
          <div className="flex justify-center">
            <FeaturedIcon icon={<AlertCircle />} size="md" color="red" border={true} />
          </div>

          <div className="flex flex-col gap-2">
            <DialogTitle align="center">{tSettings('cancelDowngradeButton')}</DialogTitle>
            <DialogDescription align="center">{tSettings('cancelDowngradeInfo')}</DialogDescription>
          </div>

          <DialogFooter className="mt-2 flex flex-col gap-3 md:flex-row">
            <Button
              size="xl"
              variant="outline"
              className="w-full md:flex-1"
              onClick={handleGoBack}
              disabled={loading}
            >
              {tBilling('keepPlan')}
            </Button>
            <Button
              size="xl"
              variant="destructive"
              className="w-full md:flex-1"
              onClick={handleConfirm}
              loading={loading}
            >
              {tSettings('cancelDowngradeButton')}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
